var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"theme-switch",attrs:{"title":'切换主题（当前：' + _vm.currentLabel + '）'}},_vm._l((_vm.themes),function(t){return _c('button',{key:t.key,staticClass:"theme-dot",class:{ active: _vm.current === t.key },style:({ background: t.preview }),attrs:{"title":t.label,"type":"button"},on:{"click":function($event){return _vm.set(t.key)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }